import Vue from 'vue';
import Toast from "vue-toastification";
import "vue-toastification/dist/index.css";

const options = {
    // You can set your default options here
    // filterBeforeCreate: (toast, toasts) => {
    //     if (toasts.filter(
    //       t => t.type === toast.type
    //     ).length !== 0) {
    //       // Returning false discards the toast
    //       return false;
    //     }
    //     // You can modify the toast if you want
    //     return toast;
    //   },
      maxToasts: 20,
};


Vue.use(Toast, options);
